import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { IconEye } from '@tabler/icons-react';
import Table from '@/components/Table';
import PageTemplate from '@/components/PageTemplate';
import agentMutations from '@/api/mutitations/agent';
import prepareTranslate from '@/helpers/dictionary';
import { formatDateToDDMMYYYY } from '@/helpers/string';
import { extractFilterOptions, filterAndSortData } from '@/components/Table/Table.functions';
import { useDisclosure } from '@mantine/hooks';
import ViewAgentExpense from '@/components/ViewAgentExpenses/ViewAgentExpense';

const ArchivedExpensesAgent = () => {
  const { id } = useParams();
  const t = prepareTranslate();
  const [filterOptions, setFilterOptions] = useState({});
  const [columnFilters, setColumnFilters] = useState({});
  const [selectedExpense, setSelectedExpense] = useState({});
  const [viewOpened, { open: openView, close: closeView }] = useDisclosure();

  const { mutateAsync: agentMutate } = agentMutations.useArchivedExpensesAgent();

  const getData = async (start, end, query, sort) => {
    try {
      const agentsData = await agentMutate({ id });
      const filteredAndSorted = filterAndSortData(agentsData.data, query, sort);
      const filtersData = extractFilterOptions(filteredAndSorted, mockColumns);
      setFilterOptions(filtersData);

      return {
        data: (filteredAndSorted || []).map((item) => ({
          ...item,
          date: formatDateToDDMMYYYY(item.date),
          payDate: formatDateToDDMMYYYY(item.payDate),
        })),
        count: filteredAndSorted?.count || 0,
      };
    } catch (error) {
      notifications.show({
        title: t('pages.archivedExpensesAgent.notification.errors.find.title'),
        message: t('pages.archivedExpensesAgent.notification.errors.find.message'),
      });
      return { data: [], count: 0 };
    }
  };

  const mockColumns = [
    {
      title: 'שם חיוב',
      accessor: 'type',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'סכום',
      accessor: 'value',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'תאריך',
      accessor: 'date',
      isVisible: true,
      isFilterActive: true,
      filterType: 'datePicker',
      sortable: true,
    },
    {
      title: 'תאריך אירכוב',
      accessor: 'archiveDate',
      isVisible: true,
      isFilterActive: true,
      filterType: 'datePicker',
      sortable: true,
      transforms: [{ func: 'date', params: { withTime: false } }],
    },
    {
      title: 'הערות',
      accessor: 'comments',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'פעולות',
      actions: [
        {
          title: 'צפייה',
          action: (_, row) => {
            setSelectedExpense(row);
            openView();
          },
          icon: <IconEye />,
          showLabel: true,
          isPrimary: true,
        },
      ],
    },
  ];

  return (
    <PageTemplate
      title={t('pages.archivedExpensesAgent.title')}
      withBackButton
    >
        <Table
          isExportActive={false}
          columns={mockColumns}
          getData={getData}
          isColumnsActive={false}
          columnFilters={columnFilters}
          setColumnFilters={setColumnFilters}
          filterOptions={filterOptions}
      />

      <ViewAgentExpense
        open={openView}
        close={closeView}
        opened={viewOpened}
        expense={selectedExpense}
      />

    </PageTemplate>
  );
};

export default ArchivedExpensesAgent;
